<template>
  <div class="branch">
    <img v-if="branch && branch.logoUrl" :src="branch.logoUrl" :alt="branch.name" class="logo" data-testid="branch-logo" />
    <div v-if="branch && branch.name" class="name" data-testid="branch-name">{{ branch.name }}</div>
  </div>
</template>

<script>
export default {
  name: 'BranchLogo',
  props: {
    branch: { type: Object, default: null }
  }
};
</script>

<style scoped>
.branch {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  text-align: center;
}
.logo {
  max-width: 100%;
  max-height: 12.6vh;
  object-fit: contain;
  /* A logo saved with a white background blends into the screen behind it
     (white x colour = colour), e.g. the tinted thank-you screen. */
  mix-blend-mode: multiply;
}
.name {
  font-size: calc(16px * var(--font-scale));
  color: #4b5563;
}
</style>
